import { TGlobalEmailSettingSchema } from '@/schemas/global-email-setting/global-email-setting.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';

const GLOBAL_EMAIL_SETTING_URI = '/globalEmailSetting';

export const getFirstGlobalEmailSetting = async () => {
  return requestApi({
    url: GLOBAL_EMAIL_SETTING_URI,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const upsertGlobalEmailSetting = async (
  globalEmailSetting: TGlobalEmailSettingSchema,
) => {
  return requestApi({
    url: GLOBAL_EMAIL_SETTING_URI,
    method: HTTP_METHOD.PUT,
    body: globalEmailSetting,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
